module.exports = __webpack_public_path__ + "img/Custom.2b2ee009.svg";